import React, { Fragment } from "react";
import MainLayout from "./layouts/main-layout.js";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

import Ajilchid from "./pages/ajilchid";
import Haih from "./pages/haih";
import Ehlel from "./pages/ehlel";
import AjiltanTasks from "./pages/ajiltanniitasks.js";
import Login from "./pages/login";
import Archive from "./pages/Archive";

const AppContent = () => {
  const navigate = useNavigate();

  const handleLogin = (token) => {
    localStorage.setItem("salon", token);
    navigate("/ehlel");
  };

  const handleLogout = () => {
    localStorage.removeItem("salon");
    navigate("/");
  };

  return (
    <Fragment>
      <MainLayout logout={handleLogout}>
        <ToastContainer autoClose={4000} />
        <Routes>
          <Route path="/" element={<Login onLogin={handleLogin} />} />
          <Route path="/ehlel" element={<Ehlel logout={handleLogout} />} />
          <Route path="/haih" element={<Haih />} />
          <Route path="/archive" element={<Archive />} />
          <Route path="/ajilchid" element={<Ajilchid />} />
          <Route path="/ajiltan/:id/:empName" element={<AjiltanTasks />} />
        </Routes>
      </MainLayout>
    </Fragment>
  );
};

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
